import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "product-card-daily",
  "use": "product-card-daily-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"product-card-daily\"><path fill=\"#003595\" fill-rule=\"evenodd\" d=\"M11.11 8.44v4.45l3.78 2.24.68-1.14-3.13-1.86V8.44h-1.33zM20 10.22V4l-2.35 2.35A7.94 7.94 0 0012 4a8 8 0 108 8h-1.78A6.23 6.23 0 0112 18.22 6.23 6.23 0 015.78 12 6.23 6.23 0 0112 5.78c1.72 0 3.27.7 4.4 1.82l-2.62 2.62H20z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol